export const blockIconsEditorAttachFile = (
	<span className='material-symbols-outlined'>attach_file</span>
);
